import React from 'react';

import { AuthProvider } from './auth';
import { AuthPermissionsProvider } from '../contexts/AuthPermissionsContext';
import { NogleTechProvider } from '../contexts/NogleTechContext';
import { ComercialProvider } from '../contexts/ComercialContext';
import { ModalMinimizerProvider } from '../contexts/ModalMinimizerContext';

const AppProvider = ({ children }) => (
    <AuthProvider>
        <AuthPermissionsProvider>
            <NogleTechProvider>
                <ComercialProvider>
                    <ModalMinimizerProvider>
                        {children}
                    </ModalMinimizerProvider>
                </ComercialProvider>
            </NogleTechProvider>
        </AuthPermissionsProvider>
    </AuthProvider>
);

export default AppProvider;
